import { useIsAdhaJourney } from '@/core/hooks';
import { HomeScreen } from '@/modules/home';
import { PropertiesListScreen } from '@/modules/properties-web/list/PropertiesListScreen';
import { Stack, useFocusEffect } from 'expo-router';
import * as React from 'react';
import { BackHandler, Platform } from 'react-native';

/**
 * Authenticated home (`/`).
 * ADHA journey (web): catalogue properties listing.
 * Email / normal journey: existing home dashboard.
 *
 * Android: intercepts the hardware back button so the app exits
 * instead of navigating back through previous screens.
 * iOS: disables the swipe-back gesture so the home screen acts as root.
 */
export default function HomeIndex() {
  const isAdhaJourney = useIsAdhaJourney();

  // Exit app on Android back press when on the home screen
  useFocusEffect(
    React.useCallback(() => {
      if (Platform.OS !== 'android') return;

      const onBackPress = () => {
        BackHandler.exitApp();
        return true; // prevents default back navigation
      };

      const subscription = BackHandler.addEventListener('hardwareBackPress', onBackPress);
      return () => subscription.remove();
    }, []),
  );

  if (Platform.OS === 'web' && isAdhaJourney) {
    return <PropertiesListScreen />;
  }

  return (
    <>
      {/* Disable iOS swipe-back gesture — home screen is the root, nothing to go back to */}
      <Stack.Screen options={{ gestureEnabled: false }} />
      <HomeScreen />
    </>
  );
}
